// hooks/useLoginModal.ts

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { openModal, setLoggedIn, setModalKey } from "@/redux/features/LoginModal/loginModalSlice";

export const useLoginModal = () => {
  const dispatch = useDispatch();
  const { isOpen, isLoggedIn, modalKey } = useSelector((state: RootState) => state.loginModal);
  return {
    isOpen,
    isLoggedIn,
    modalKey,
    open: () => dispatch(openModal()),
    setLoggedIn: (val: boolean) => dispatch(setLoggedIn(val)),
    setModalKey: (key?: string) => dispatch(setModalKey(key)),
  };
};
